import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * Search by Image experiment arms. treatmenta renders the camera entry beside the search
 * input; treatmentb renders the camera inside the input; both open the same upload popover /
 * bottom sheet. One base call per arm so Amplitude exposure fires for every bucket, not just
 * the one the UI reads — resolve this hook in an always-mounted place (HammerHeader) so
 * control fires exposure too.
 */
export const useSearchByImageExperiment = () => {
    const hasControl = useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchByImage,
        AmplitudeVariants.SearchByImage.Control
    );

    const hasTreatmentA = useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchByImage,
        AmplitudeVariants.SearchByImage.TreatmentA
    );

    const hasTreatmentB = useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchByImage,
        AmplitudeVariants.SearchByImage.TreatmentB
    );

    return {
        hasControl,
        hasTreatmentA,
        hasTreatmentB,
    };
};
